module.exports = __webpack_public_path__ + "static/RB-a3b65e60b8f45fe9ffe46f81d108f212.jpg";